import { render } from "./MenusTable.vue?vue&type=template&id=e60c8a66"
import script from "./MenusTable.vue?vue&type=script&lang=js"
export * from "./MenusTable.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/moncasan_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__